var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"tab-component",attrs:{"fixed-tabs":""}},[_vm._l((_vm.items),function(item){return [_c('v-tab',{key:item},[_vm._v(_vm._s(item))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }